import { makeCall, Methods } from "../../utils/makeCall";
import { ApiConfigs } from "./configs.entity";
import { GetConfigErrors } from "./configs.error";

export type GetConfigRequest = void;
export type GetConfigResponse = ApiConfigs;

export const getConfig = makeCall<
  GetConfigRequest,
  GetConfigResponse,
  GetConfigErrors
>(Methods.GetConfig);
